/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitdone2Inputs */

const en_coverfitdone2 = /** @type {(inputs: Coverfitdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusted cover added in front; the original stays in the gallery.`)
};

const de_coverfitdone2 = /** @type {(inputs: Coverfitdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepasstes Titelbild vorne eingefügt, das Original bleibt in der Galerie.`)
};

/**
* | output |
* | --- |
* | "Adjusted cover added in front; the original stays in the gallery." |
*
* @param {Coverfitdone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitdone2 = /** @type {((inputs?: Coverfitdone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitdone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitdone2(inputs)
	return de_coverfitdone2(inputs)
});
export { coverfitdone2 as "coverFitDone" }